import { render, staticRenderFns } from "./acceptanceRecord.vue?vue&type=template&id=7201784a&scoped=true"
import script from "./acceptanceRecord.vue?vue&type=script&lang=js"
export * from "./acceptanceRecord.vue?vue&type=script&lang=js"
import style0 from "./acceptanceRecord.vue?vue&type=style&index=0&id=7201784a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7201784a",
  null
  
)

export default component.exports